import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { largeDataAnalyticsAsyncThunks } from '../Api/largeDataAnalyticsExternalApi';
import {
  selectAllLargeDataModels,
  selectLatestLargeDataModel,
  selectAllScenarios,
  selectLatestScenario
} from '../Store/slices/largeDataAnalytics.slice';

// Custom hook for fetching rank features


export const useRankFeatures = () => {
  const dispatch = useDispatch();
  const rankFeatures = useSelector((state) => selectAllLargeDataModels(state, 'analysis/rankFeatures'));
  const attrinbutionAnalysis = useSelector((state) => selectAllLargeDataModels(state, 'models/attribution'));

  const fetchRankFeatures = useCallback((params) => {
    dispatch(largeDataAnalyticsAsyncThunks['analysis/rankFeatures'](params));
  }, [dispatch]);

  return {
    rankFeatures,
    fetchRankFeatures,
  };
};



const useLargeDataAnalyticsApi = () => {
  const dispatch = useDispatch();
  const attributionAnalysis = useSelector((state) => selectAllLargeDataModels(state, 'models/attribution'));

  const performAttributionAnalysis = useCallback((tickers)=>{
    dispatch(largeDataAnalyticsAsyncThunks['models/attribution']({symbols: tickers}))
  });

  return { attributionAnalysis, performAttributionAnalysis };


}

export default useLargeDataAnalyticsApi;


